import React, { type ReactElement } from "react";
import { SitesPanelSettings, SitesPanelObservatory } from "@/components";

function SitesMovablePanelList(): ReactElement {
  return (
    <div className="absolute inset-0 z-20 pointer-events-none">
      <SitesPanelSettings />
      <SitesPanelObservatory />
    </div>
  );
}

export { SitesMovablePanelList };
